/**
 * Labstep
 *
 * @module components/OrderRequest/Action/Duplicate
 * @desc Orderrequest action duplicate
 */

import { EntityActionDuplicate } from 'labstep-web/components/Entity/Action/Duplicate';
import type React from 'react';
import type { OrderRequestActionDuplicateProps } from './types';

export const OrderRequestActionDuplicate: React.FC<
  OrderRequestActionDuplicateProps
> = ({ orderRequest }) => (
  <EntityActionDuplicate entity={orderRequest} />
);
